import { $themeConfig } from '@themeConfig';
import Vue from 'vue';
import useJwt from '@/auth/jwt/useJwt';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import router from '../../router';
import app from '@/main';
import { Promise } from 'core-js';
let initialState = {
  service_types: [],
  ports: [],
  incoterms: [],
  locations: [],
  cont_types: [],
  goods_types: [],

  transport_types: [],
  business_types: [],
  customs_types: [],
  shipping_lines: [],
  handed_types: [],
  regions: [],



  // regions: [],
  // countries: [],
  // users: [],
  // companyItems: [],
  // companyItemsName: [],
  // sales: [],
  // banks: [],
  // LocationTypes: [],
  // exchangeRate: [],
 


  // deports_locations: [],
  // deports: [],
  // fee_types: [],
  // acc_dept: [],
  // customer_list_options: [],
  // handed_types: [],
  // vessel: [],
  // shippingDetails: null,
}
export default {
  namespaced: true,
  state: {
    regions: [],

    service_types: [],
    ports: [],
    incoterms: [],
    locations: [],
    cont_types: [],
    goods_types: [],
  
    transport_types: [],
    business_types: [],
    customs_types: [],
    shipping_lines: [],
    handed_types: [],

  },
  getters: {
    getLocationTypes: state => {
      return formatOption(state.LocationTypes);
    },
    exchangeRate: state => {
      return state.exchangeRate.value;
    },
  },
  mutations: {

    RESET_STATE(state, payload) {
      for (let f in state) {
        if (initialState[f]) {
          Vue.set(state, f, initialState[f])

        }
      }
    },
  
    FETCH_REGION(state, payload) {
      state.regions = payload;
    },

    FETCH_COMPANY_ITEMS(state, payload) {
      state.companyItems = payload;
    },
    FETCH_COMPANY_ITEMS_NAME(state, payload) {
      state.companyItemsName = payload;
    },




    SET_SERVICE_TYPE(state, payload) {
      state.service_types = payload;
    },
    SET_PORT(state, payload) {
      state.ports = payload;
    },

    SET_INCOTERMS(state, payload) {
      state.incoterms = payload;
    },
    SET_LOCATION(state, payload) {
      state.locations = payload;
    },

    SET_CONT_TYPE(state, payload) {
      state.cont_types = payload;
    },
    SET_GOOD_TYPE(state, payload) {
      state.goods_types = payload;
    },

    SET_TRANSPORT_TYPES(state, payload) {
      state.transport_types = payload;
    },
 

    SET_BUSINESS_TYPE(state, payload) {
      state.business_types = payload;
    },
    SET_CUSTOMS_TYPE(state, payload) {
      state.customs_types = payload;
    },
    SET_SHIPPING_TYPE(state, payload) {
      state.shipping_lines = payload;
    },

    SET_HANDLER_TYPE(state, payload) {
      state.handed_types = payload;
    },


  },

  actions: {

    fetchServiceTypes({ commit, state }) {
      if (state.service_types.length == 0) {
        return new Promise((resolve, reject) => {
          useJwt
            .get('masterDataNologin', { params: { data: 'ServiceType' } })
            .then(response => {
              commit('SET_SERVICE_TYPE', response.data.result);
              resolve(response.data.result);
            })
            .catch(error => {
              resolve(false);
            });
        });
      }
    },

    // fetchCompany: function ({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     if (state.companyItems.length == 0) {
    //       useJwt
    //         .get('masterDataNologin?data=Company', {})
    //         .then(response => {
    //           var mapCompany = response.data.result.map(obj => {
    //             obj.text = obj.code + ' - ' + obj.text || obj.name;
    //             obj.id = obj.code;
    //             obj.Acronym = obj.acronym;
    //             return obj;
    //           });

    //           commit('FETCH_COMPANY_ITEMS', mapCompany);
    //           commit('FETCH_COMPANY_ITEMS_NAME', mapCompany);

    //           resolve(mapCompany);
    //         })
    //         .catch(error => {
    //           this.$toast({
    //             component: ToastificationContent,
    //             props: {
    //               title: 'Something went wrong, please try again',
    //               icon: 'AlertTriangleIcon',
    //               variant: 'danger',
    //             },
    //           });
    //         });
    //     }
    //   });
    // },
    fetchRegion({ commit, state }) {
      if (state.regions.length == 0) {
        useJwt
          .get('masterDataNologin?data=Region')
          .then(response => {
            commit('FETCH_REGION', formatOption(response.data.result));
          })
          .catch(error => {
            app.$toast({
              component: ToastificationContent,
              props: {
                title: 'Something went wrong, please try again',
                icon: 'CheckSquareIcon',
                variant: 'danger',
              },
            });
          });
      }
    },
    fetchPort({ commit, state }) {
      if (state.ports.length == 0) {
        useJwt.get('masterDataNologin?data=Port').then(response => {
          commit('SET_PORT', formatOption(response.data.result));
        });
      }
    },
    fetchIncoterm({ commit, state }) {
      if (state.incoterms.length == 0) {
        useJwt.get('masterDataNologin?data=Incoterm').then(response => {
          commit('SET_INCOTERMS', formatOption(response.data.result));
        });
      }
    },
    fetchLocations({ commit, state }) {
        useJwt.get('masterDataNologin?data=Location').then(response => {
          commit('SET_LOCATION', response.data.result);
          commit('SET_DEPORTS_LOCATION', response.data.result);
        });
    },
    fetchContType({ commit, state }) {
      if (state.cont_types.length == 0) {
        useJwt.get('masterDataNologin?data=ContType').then(response => {
          commit('SET_CONT_TYPE', formatOption(response.data.result));
        });
      }
    },
    fetchGoodsType({ commit, state }) {
      if (state.goods_types.length == 0) {
        useJwt.get('masterDataNologin?data=GoodsType').then(response => {
          commit('SET_GOOD_TYPE', response.data.result);
        });
      }
    },
    fetchTransportsType({ commit, state }) {
      if (state.transport_types.length == 0) {
        useJwt.get('masterDataNologin?data=TransportType').then(response => {
          commit('SET_TRANSPORT_TYPES', response.data.result);
        });
      }
    },


    fetchBusinessType({ commit, state }) {
      if (state.business_types.length == 0) {
        useJwt.get('masterDataNologin?data=BusinessType').then(response => {
          commit('SET_BUSINESS_TYPE', response.data.result);
        });
      }
    },

    fetchCustomsType({ commit, state }) {
      if (state.customs_types.length == 0) {
        useJwt.get('masterDataNologin?data=CustomsType').then(response => {
          commit('SET_CUSTOMS_TYPE', response.data.result);
        });
      }
    },





    fetchShippingLine({ commit, state }) {
      if (state.shipping_lines.length == 0) {
        useJwt.get('masterDataNologin?data=ShippingLine').then(response => {
          const data = response.data.result;
          const mapData = data.map(obj => {
            obj.text = obj.code + ' - ' + obj.name || '';
            return obj;
          });

          commit('SET_SHIPPING_TYPE', mapData);
        });
      }
    },


    fetchHandedType({ commit, state }) {
      if (state.handed_types.length == 0) {
        useJwt.get('masterDataNologin?data=HandedType').then(response => {
          commit('SET_HANDLER_TYPE', response.data.result);
        });
      }
    },


    FETCH_ALL: ({ dispatch }) => {
      // Dispatch all the actions here
      
      dispatch('fetchServiceTypes');

      dispatch('fetchPort');
      dispatch('fetchIncoterm');
      dispatch('fetchContType');

      dispatch('fetchGoodsType');

      dispatch('fetchTransportsType');


      dispatch('fetchBusinessType');

      dispatch('fetchCustomsType');
      dispatch('fetchShippingLine');
      // dispatch('fetchCompany');

      // dispatch('fetchLocations');
      dispatch('fetchHandedType');
      dispatch('fetchRegion');

      



      //...
    },
  },
};

function formatOption(arr) {
  const mapData = arr.map(obj => {
    obj.text = obj.text || obj.name;
    obj.id = obj.code;
    return obj;
  });
  return mapData;
}
